module.exports = __webpack_public_path__ + "static/media/plus.baa384b6.svg";